import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { useController, UseControllerProps } from 'react-hook-form'
import { Textarea } from '@/components/ui/textarea'

interface Props {
  label?: string
  placeholder?: string
  disabled?: boolean
}
export function TextAreaForm(props: Props & UseControllerProps<any>) {
  const { control, name, label, placeholder, disabled } = props
  const { fieldState } = useController(props)
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {label && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <Textarea
              placeholder={placeholder}
              {...field}
              value={field.value ?? ''}
              disabled={disabled}
            />
          </FormControl>
          <FormMessage>{fieldState.error?.message}</FormMessage>
        </FormItem>
      )}
    />
  )
}
